<script setup lang="ts">
import type { ProductDocument } from "@/schemas/product-document";

defineProps<{ products: ProductDocument[] }>();
</script>

<template>
  <UiEmptyResult v-if="!products.length" title="Aucun produit à afficher" />
  <div v-else class="grid grid-cols-1 gap-x-8 gap-y-16 md:grid-cols-2 lg:grid-cols-3">
    <ProductGridItem v-for="product in products" :key="product.product_id" :product="product" />
  </div>
</template>
